import React, { Component } from 'react';
import { Formik } from 'formik';
import { Space, Button, Form, Alert } from "antd";
import * as Yup from 'yup';
import { find } from 'lodash';
import * as constants from '../../constants';

import common from '../../../../common';
import core from '../../../core';


const { TextInput, SelectInput, MultiSelectInput, DisplayFormikState } = core;

const FormItem = Form.Item;

const FormSchema = Yup.object().shape({
    idSecurityMeasure: Yup.array().min(1).required('*'),
});

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 },
}

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 4,
        },
    },
};

class SecurityMeasureForm extends Component {

    onSave = async (values, { setSubmitting, setErrors }) => {
        if (this.props.onSave) {

            let sm = [];
            let count = -1;
            let idProcessedData = this.props.datacontext.idProcessedData;
            if (values.idSecurityMeasure) {
                values.idSecurityMeasure.forEach(i => {
                    let securitymeasure = find(this.props.picklists.securityMeasures, { 'id': i });
                    sm.push({ id: count, idProcessedData: idProcessedData, idSecurityMeasure: securitymeasure.id, nameSecurityMeasure: securitymeasure.name, name: securitymeasure.id == 99 ? values.name : undefined })
                    count--;
                })
            }

            await this.props.onSave(sm);
            setSubmitting(false);
        } else {
            setSubmitting(false)
        }
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'SecurityMeasureForm', key);
    }

    CreateForm = (props) => {
        //console.log(props);
        const userHasReadonlyRights = false; //!this.props.currentUsersCompanyRights.includes(common.rights.BedrijfMuteren);

        return (
            <Form layout='horizontal' style={{ margin: 10 }}>
                <MultiSelectInput {...props} name="idSecurityMeasure" label={this.label("SecurityMeasures")} formItemLayout={formItemLayout}
                    nameField="name" idField="id" items={this.props.picklists.securityMeasures} placeholder={this.label("DdlPlaceholder")} />
                {props.values.idSecurityMeasure && props.values.idSecurityMeasure.includes(99) &&
                    <TextInput {...props} name="name" readOnly={userHasReadonlyRights} label={this.label("OtherValue")} formItemLayout={formItemLayout} />
                }
                <FormItem {...tailFormItemLayout}>
                    <Space.Compact className='entity-form-btns'>
                        <Button disabled={props.isSubmitting || userHasReadonlyRights} onClick={this.props.onCancel}>{this.label("Cancel")} </Button>
                        <Button type="primary" onClick={() => props.handleSubmit()} disabled={props.isSubmitting || userHasReadonlyRights} > {this.label("Save")} </Button>
                    </Space.Compact>
                </FormItem>
                {props.isSubmitting &&
                    <Alert
                        message={this.label("Saving")}
                        style={{ marginTop: 20 }}
                    />
                }
                {/* <DisplayFormikState {...props} /> */}
            </Form>
        )
    }

    render() {
        return (
            <Formik enableReinitialize={true}
                initialValues={this.props.datacontext}
                validationSchema={FormSchema}
                onSubmit={this.onSave}
                render={this.CreateForm}
                innerRef={p => (this.formik = p)}
            />
        );
    }
}

export default SecurityMeasureForm